import script from "./FaqHome.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqHome.vue?vue&type=script&setup=true&lang=js"

import "./FaqHome.vue?vue&type=style&index=0&id=205bf000&lang=scss"

const __exports__ = script;

export default __exports__